export default __webpack_public_path__ + "static/media/photo7.3e976750.jpg";